// The backend's SearchError::CODE_RENEWING: the carrier connection is being renewed in the background.
export const onlineRateRenewingCode = "renewing";

// A carrier answered only that its connection is being renewed; asking again later brings the rates.
export class OnlineCarrierRenewingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "OnlineCarrierRenewingError";
  }
}
